<template>
    <section class="innerpages animate__animated animate__slideInRight">
       <div class="container ">
          <div class="row">
             <div class="col-md-12">
                <div class="filterTabs">
                   <div class="tab-content">
                          <div class="card">
                            <b-table
                              :items="masterData"
                              :fields="fields"
                              @row-clicked="openDetails"
                              tbody-tr-class="dataDivider"
                              sort-icon-right
                              responsive="sm"
                              show-empty
                            >
                              <template v-slot:cell(report)="data">
                                <i style="font-style: normal">
                                  {{ data.value }} 
                                  <span class="icon-arrow">
                                    <svg
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      x="0px" y="0px"
                                      viewBox="0 0 407.436 407.436"
                                      style="enable-background:new 0 0 407.436;"
                                      xml:space="preserve"
                                    >
                                      <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718"></polygon>
                                    </svg>
                                  </span>
                                </i>
                              </template>
                            </b-table>
                         </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </section>
  </template>
  <script>
  export default {
    data() {
    return {
      fields: [{ key: 'report', label: 'Report Name' }],
      masterData: [
        { report: 'Sub Source Report', label: 'SubSource-Wise' },
        { report: 'Qualification Report', label: 'Qualification' },
        { report: 'Call Activity Report', label: 'Call-Activity' },
        { report: 'Backlog Report', label: 'Backlog' },
        { report: 'ROI User Wise Report', label: 'UserRoi' },
        { report: 'ROI Project Wise Report', label: 'ProjectRoi' },
        { report: 'ROI Source Wise Report', label: 'SourceRoi' },
        { report: 'Marketing Activation Report', label: 'MarketingActivation' },
        { report: 'Marketing Campaign Report', label: 'MarketingCampaignReport' },
        { report: 'Pipeline Report', label: 'PipelineReport' },
        { report: 'Lead Ageing Report', label: 'LeadAgeingReports' }
      ]
    };
  },
  created(){
   this.$store.dispatch('setActiveTitle', "Report List");
   this.$store.dispatch('clearFilters');
   if (Object.keys(this.$route.query).length !== 0) {
    this.$router.replace({ path: this.$route.path, query: {} });
  }

  },
   methods: {
    openDetails(item, index) {
      localStorage.setItem('selectedtabkey', '');
      this.$router.push({name: item.label});    
    }
   },
  }
  </script>